import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseLayoutComponent } from './components/base-layout/base-layout.component';
import { MainHeaderComponent } from './components/main-header/main-header.component';
import { CanvasComponent } from './components/canvas/canvas.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { LayoutEffects } from './store/effects/layout.effects';
import * as reducer from './store/reducers/layout.reducer';
import { BentoModule } from '@bento/bento-ng';
import { LayoutService } from '../core/services/layout.service';
import { RouterModule, Routes } from '@angular/router';
import { RightPanelComponent } from './components/right-panel/right-panel.component';
import { CanvasNoHeaderComponent } from './components/canvas-no-header/canvas-no-header.component';
import { ContainerRightPanelComponent } from './components/container-right-panel/container-right-panel.component';

const routes: Routes = [
  {path: 'dashboard', component: BaseLayoutComponent}
];
@NgModule({
  declarations: [MainHeaderComponent, CanvasComponent, BaseLayoutComponent, RightPanelComponent, CanvasNoHeaderComponent, ContainerRightPanelComponent ],
  imports: [
    CommonModule,
    BentoModule ,
    RouterModule.forRoot(routes),
    StoreModule.forFeature('layout', reducer.reducer),
   EffectsModule.forFeature([LayoutEffects])
  ],
  providers: [LayoutService]
})
export class LayoutModule { }
